// @flow

import React, { type Node } from 'react';
import { Portal } from '@tectonics/commons/portal';
import { Header, TextBlock } from '../../../../../atoms';

export function StatusMessage(): Node {
  return (
    <Portal id="bromelia-status-message">
      <Header size={2}>Pedido pendente</Header>
      <TextBlock flavor="normal">Assim que o boleto for pago você receberá uma confirmação de seu pedido.</TextBlock>
    </Portal>
  );
}
